<div [ngStyle]="{'border-bottom':(textStyle && textStyle.includes('underline')) ? '1px solid black':null}" *ngIf="visible">
    <span [ngStyle]="{'fontWeight':(textStyle && textStyle.includes('bold')) ? 'bold' : 'inherit',
'fontStyle':(textStyle && textStyle.includes('italic')) ? 'italic' : 'inherit'}">{{value | dt:displayFormat}}</span>
</div>